module.exports = __webpack_public_path__ + "img/mobile-layout-01.a8b02227.jpg";